export default __webpack_public_path__ + "static/media/cenote-in-mexico-3.e9cc7143.jpeg";